// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","526":"pages-DebugPage","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"0a971316d3d6a7059730","513":"564da2f70ac9f6d7e98b","526":"fb41f669c9ca6a5074dd","777":"03fe3f4c34e0611d0b4b"}[chunkId] + ".js";
};